/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppDeleteCompositionsDetailMutationResponse, WebAppDeleteCompositionsDetailPathParams, WebAppDeleteCompositionsDetail401, WebAppDeleteCompositionsDetail403, WebAppDeleteCompositionsDetail404 } from "../models/WebAppDeleteCompositionsDetail";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { webAppDeleteCompositionsDetail } from "../axios/webAppDeleteCompositionsDetail";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const webAppDeleteCompositionsDetailMutationKey = () => [{ url: '/web-app/v1/compositions/:id' }] as const

export type WebAppDeleteCompositionsDetailMutationKey = ReturnType<typeof webAppDeleteCompositionsDetailMutationKey>

export function webAppDeleteCompositionsDetailMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = webAppDeleteCompositionsDetailMutationKey()
        return mutationOptions<WebAppDeleteCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppDeleteCompositionsDetail401 | WebAppDeleteCompositionsDetail403 | WebAppDeleteCompositionsDetail404>, {id: WebAppDeleteCompositionsDetailPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return webAppDeleteCompositionsDetail(id, config)
          },
        })

}

/**
 * @summary Delete a composition by id
 * {@link /web-app/v1/compositions/:id}
 */
export function useWebAppDeleteCompositionsDetail<TContext>(options: 
{
  mutation?: UseMutationOptions<WebAppDeleteCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppDeleteCompositionsDetail401 | WebAppDeleteCompositionsDetail403 | WebAppDeleteCompositionsDetail404>, {id: WebAppDeleteCompositionsDetailPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? webAppDeleteCompositionsDetailMutationKey()

          const baseOptions = webAppDeleteCompositionsDetailMutationOptions(config) as UseMutationOptions<WebAppDeleteCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppDeleteCompositionsDetail401 | WebAppDeleteCompositionsDetail403 | WebAppDeleteCompositionsDetail404>, {id: WebAppDeleteCompositionsDetailPathParams["id"]}, TContext>
          

          return useMutation<WebAppDeleteCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppDeleteCompositionsDetail401 | WebAppDeleteCompositionsDetail403 | WebAppDeleteCompositionsDetail404>, {id: WebAppDeleteCompositionsDetailPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WebAppDeleteCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppDeleteCompositionsDetail401 | WebAppDeleteCompositionsDetail403 | WebAppDeleteCompositionsDetail404>, {id: WebAppDeleteCompositionsDetailPathParams["id"]}, TContext>
      
}